<mat-tab-group>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="mr-2">quiz</mat-icon>
            <span>Quests</span>
        </ng-template>
        <ng-template matTabContent>
            <app-quests></app-quests>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="mr-2">integration_instructions</mat-icon>
            <span>Templates</span>
        </ng-template>
        <ng-template matTabContent>
            <app-quests-templates></app-quests-templates>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="mr-2">schedule</mat-icon>
            <span>Schedules</span>
        </ng-template>
        <ng-template matTabContent>
            <app-quests-schedules></app-quests-schedules>
        </ng-template>
    </mat-tab>
</mat-tab-group>
